import { useSeo } from '@/hooks/useSeo';
import { buildPageTitle } from '@/lib/seo';
import { Button } from '@/components/common/Button/Button';
import { Card } from '@/components/common/Card/Card';
import { PageBreadcrumb } from '@/components/layout/PageBreadcrumb/PageBreadcrumb';
import { StepHeader } from '@/components/layout/StepHeader/StepHeader';

import layoutStyles from '@/styles/layout.module.css';
import styles from '@/styles/legal.module.css';

export function TermsPage(): JSX.Element {
  useSeo({
    title: buildPageTitle('Termos de Uso'),
    description: 'Regras de uso, limites de responsabilidade e créditos do Verde Confirma.',
    canonicalPath: '/termos',
    ogType: 'website',
  });

  return (
    <section className={styles.page}>
      <PageBreadcrumb items={[{ label: 'Início', to: '/' }, { label: 'Termos de uso' }]} />

      <StepHeader
        kicker="Institucional"
        title="Termos de Uso"
        description="Ao acessar o Verde Confirma, você concorda com estas condições de uso e com as limitações descritas abaixo."
        actions={<Button to="/" variant="secondary" size="sm">Voltar ao início</Button>}
      />

      <div className={styles.content}>
        <Card tone="soft" className={styles.sectionCard}>
          <p className={layoutStyles.sectionTitle}>1. Sobre o serviço</p>
          <p className={styles.bodyText}>
            O Verde Confirma é uma plataforma informativa para consultar propostas, comparar candidatos e visualizar o Match Político com base em fontes públicas e documentos oficiais.
          </p>
          <p className={styles.bodyText}>
            O conteúdo não constitui recomendação de voto, aconselhamento jurídico, político ou profissional.
          </p>
        </Card>

        <Card tone="soft" className={styles.sectionCard}>
          <p className={layoutStyles.sectionTitle}>2. Uso permitido</p>
          <ul className={styles.list}>
            <li className={styles.listItem}>consultar as páginas públicas do site;</li>
            <li className={styles.listItem}>compartilhar links públicos sem alterar a origem do conteúdo;</li>
            <li className={styles.listItem}>usar o material para fins pessoais, cívicos e informativos.</li>
          </ul>
        </Card>

        <Card tone="soft" className={styles.sectionCard}>
          <p className={layoutStyles.sectionTitle}>3. Conteúdo e fontes</p>
          <p className={styles.bodyText}>
            Parte do conteúdo é organizada automaticamente a partir de dados públicos, documentos oficiais e processamento assistido por sistemas de IA.
          </p>
          <p className={styles.bodyText}>
            Embora haja revisão e referências, podem existir erros, omissões ou interpretações incompletas. A checagem nas fontes originais continua sendo responsabilidade do usuário.
          </p>
        </Card>

        <Card tone="soft" className={styles.sectionCard}>
          <p className={layoutStyles.sectionTitle}>4. Limites de responsabilidade</p>
          <ul className={styles.list}>
            <li className={styles.listItem}>não garantimos exatidão absoluta, disponibilidade contínua ou ausência de falhas;</li>
            <li className={styles.listItem}>links externos e documentos de terceiros são de responsabilidade de seus respectivos titulares;</li>
            <li className={styles.listItem}>o uso das informações é feito por conta e risco do usuário.</li>
          </ul>
        </Card>

        <Card tone="soft" className={styles.sectionCard}>
          <p className={layoutStyles.sectionTitle}>5. Propriedade intelectual</p>
          <p className={styles.bodyText}>
            A marca, o layout e os textos originais do Verde Confirma pertencem aos seus respectivos responsáveis. Conteúdos de terceiros permanecem sob a titularidade de seus autores e fontes.
          </p>
        </Card>

        <Card className={styles.creditCard}>
          <p className={styles.creditTitle}>Crédito do projeto</p>
          <p className={styles.metaText}>
            Site desenvolvido por{' '}
            <a className={styles.inlineLink} href="https://dikaiosun.com.br/" target="_blank" rel="noreferrer noopener">
              Dikaiosun
            </a>
            .
          </p>
        </Card>
      </div>
    </section>
  );
}
